<script>
    const {
        class: className,
        icon,
        label
    } = $props();
</script>

<svg class={className}
     fill="currentColor"
     role={label ? 'img' : 'presentation'}
     aria-label={label}
     aria-hidden={label ? undefined : 'true'}
     focusable="false"
     viewBox="0 0 24 24"
     xmlns="http://www.w3.org/2000/svg">
    <g fill="currentColor">
        <path d="{icon}"></path>
    </g>
</svg>
